module.exports = __webpack_public_path__ + "static/media/Montserrat-Black.4a06f1af.woff2";